/* eslint-disable default-case */
import {
  Button,
  Grid,
  Selector,
  Slider,
  Space,
  Stepper,
  Toast,
} from "antd-mobile"
import { useCallback, useEffect, useMemo, useState } from "react"
import { DATA_TYPE, getData, setData } from "../../api/userData"

/**
 * Низкая (сидячий образ жизни) – 1,20
 * Малая (1-3 раза в неделю легкие тренировки) – 1,38
 * Средняя (1-5 раза в неделю умеренные тренировки) – 1,55
 * Высокая (5-7 раза в неделю интенсивные тренировки) – 1,73
 */

const ACTIVITY_1 = 1.1
const ACTIVITY_2 = 1.375
const ACTIVITY_3 = 1.55
const ACTIVITY_4 = 1.725

const ACTIVITY = [ACTIVITY_1, ACTIVITY_2, ACTIVITY_3, ACTIVITY_4]

const defaulProfile = {
  sex: "female",
  weight: 56,
  height: 165,
  age: 25,
  activity: "1",
  kkal: 2000,
  fat: 20,
  prot: 30,
  carb: 50,
  dietmode: "1",
}

function Profile() {
  const [myProfile, setMyProfile] = useState(defaulProfile)
  const [kkal, setKkal] = useState(2000)

  useEffect(() => {
    const data = getData(DATA_TYPE.PROFILE)
    if (Object.keys(data).length) {
      setMyProfile(data)
    }
  }, [])

  useEffect(() => {
    let metabalism = 0
    const { sex, weight, height, age, activity } = myProfile

    if (sex === "male") {
      metabalism = 66 + 13.7 * weight + 5 * height - 6.8 * age
    } else {
      metabalism = 655 + 9.6 * weight + 1.8 * height - 4.7 * age
    }

    const _kkal = metabalism * ACTIVITY[activity ? activity - 1 : 0] * 1

    setKkal(parseInt(_kkal))

    // setFat(20)
    // setProt(30)
    // setCarb(50)

    // console.log({ _kkal })
  }, [myProfile])

  const onChange = useCallback(
    (type, value) => {
      setMyProfile((prev) => {
        if (type === "dietmode") {
          switch (value) {
            case "1": {
              return { ...prev, [type]: value, fat: 20, prot: 30, carb: 50 }
            }
            case "2": {
              return { ...prev, [type]: value, fat: 30, prot: 30, carb: 40 }
            }
            case "3": {
              return { ...prev, [type]: value, fat: 20, prot: 50, carb: 30 }
            }
          }
        }

        switch (type) {
          case "fat": {
            let prot = 100 - prev.carb - value
            if (prot < 0) prot = 0
            return { ...prev, [type]: value, prot }
          }

          case "prot": {
            let carb = 100 - prev.fat - value
            if (carb < 0) carb = 0
            return { ...prev, [type]: value, carb }
          }

          case "carb": {
            let fat = 100 - prev.prot - value
            if (fat < 0) fat = 0
            return { ...prev, [type]: value, fat }
          }
        }

        return { ...prev, [type]: value }
      })
      setData(DATA_TYPE.PROFILE, { ...myProfile, [type]: value })
      openNotification()
    },
    [myProfile]
  )

  const openNotification = () => {
    Toast.show({
      content: "Обновленно",
      position: "bottom",
    })
  }

  const isManual = useMemo(() => {
    console.log(myProfile?.dietmode)
    return myProfile?.dietmode === "4"
  }, [myProfile])

  return (
    <Grid
      columns={12}
      gap={12}
      style={{
        paddingTop: 820,
        paddingBottom: 120,
        marginLeft: 16,
        marginRight: 16,
        width: "100%",
      }}
    >
      <Grid.Item span={12}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <img style={{ margin: "auto" }} src="mf.png" alt="" width={220} />
        </div>

        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button
            block
            color="primary"
            fill="none"
            onClick={() => onChange("sex", "male")}
          >
            Я мужчина
          </Button>
          <Button
            block
            color="primary"
            fill="none"
            onClick={() => onChange("sex", "female")}
          >
            Я женщина
          </Button>
        </div>
        <div style={{ display: "flex", flexDirection: "row", paddingTop: 16 }}>
          <p style={{ width: "50%", textAlign: "right", paddingRight: 16 }}>
            Мой возраст:
          </p>
          <Stepper
            defaultValue={25}
            value={myProfile?.age}
            step={1}
            min={18}
            max={80}
            onChange={(value) => onChange("age", value)}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "row", paddingTop: 16 }}>
          <p style={{ width: "50%", textAlign: "right", paddingRight: 16 }}>
            Мой рост:
          </p>
          <Stepper
            defaultValue={165}
            value={myProfile?.height}
            step={1}
            min={120}
            max={210}
            onChange={(value) => onChange("height", value)}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "row", paddingTop: 16 }}>
          <p style={{ width: "50%", textAlign: "right", paddingRight: 16 }}>
            Мой вес:
          </p>
          <Stepper
            defaultValue={56}
            value={myProfile?.weight}
            step={1}
            min={30}
            max={130}
            onChange={(value) => onChange("weight", value)}
          />
        </div>
        <p style={{ paddingTop: 8 }}>Моя активность:</p>
        <Selector
          columns={1}
          options={[
            {
              label: "Низкая",
              description: "Сидячий образ жизни",
              value: "1",
            },
            {
              label: "Легкие тренировки",
              description: "1-3 в неделю",
              value: "2",
            },
            {
              label: "Умеренные",
              description: "1-5 в неделю",
              value: "3",
            },
            {
              label: "Интенсивные",
              description: "5-7 в неделю",
              value: "4",
            },
          ]}
          value={[myProfile?.activity]}
          defaultValue={["1"]}
          onChange={(value) => onChange("activity", value.join())}
        />
        <p style={{ paddingTop: 16 }}>Параметры для расчёта калорий/ЖБУ:</p>
        <Selector
          style={{
            "--padding": "16px 30px",
          }}
          columns={1}
          options={[
            {
              label: "Стандартный",
              value: "1",
            },
            {
              label: "Похудение (ЖБУ 30-30-40)",
              value: "2",
            },
            {
              label: "Сушка (ЖБУ 20-50-30)",
              value: "3",
            },
            {
              label: "Ручная установка",
              value: "4",
            },
          ]}
          defaultValue={["1"]}
          value={[myProfile?.dietmode]}
          onChange={(value) => onChange("dietmode", value.join())}
        />
        <div style={{ display: "flex", flexDirection: "row", paddingTop: 16 }}>
          <p
            style={{
              width: "50%",
              textAlign: "right",
              paddingRight: 16,
            }}
          >
            Ккал:
          </p>
          <p>{kkal}</p>
        </div>
        <Slider
          disabled={!isManual}
          step={100}
          defaultValue={2000}
          min={1200}
          max={4500}
          value={myProfile.kkal}
          onChange={(value) => onChange("kkal", parseInt(value))}
        />
        <Space />
        <div style={{ display: "flex", flexDirection: "row", paddingTop: 16 }}>
          <p
            style={{
              width: "50%",
              textAlign: "right",
              paddingRight: 16,
            }}
          >
            Жиры:
          </p>
          <p>
            {myProfile.fat}%{" "}
            {parseInt((myProfile.kkal * myProfile.fat) / 100 / 9)} г.
          </p>
        </div>
        <Slider
          disabled={!isManual}
          defaultValue={20}
          step={10}
          min={0}
          max={100}
          value={myProfile.fat}
          onChange={(value) => onChange("fat", parseInt(value))}
        />
        <Space />
        <div style={{ display: "flex", flexDirection: "row", paddingTop: 16 }}>
          <p
            style={{
              width: "50%",
              textAlign: "right",
              paddingRight: 16,
            }}
          >
            Белки:
          </p>
          <p>
            {myProfile.prot}%{" "}
            {parseInt((myProfile.kkal * myProfile.prot) / 100 / 4)} г.
          </p>
        </div>
        <Slider
          disabled={!isManual}
          defaultValue={20}
          step={10}
          min={0}
          max={100}
          value={myProfile.prot}
          onChange={(value) => onChange("prot", parseInt(value))}
        />
        <Space />

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingTop: 16,
          }}
        >
          <p
            style={{
              width: "50%",
              textAlign: "right",
              paddingRight: 16,
            }}
          >
            Углеводы:
          </p>
          <p>
            {myProfile.carb}%{" "}
            {parseInt((myProfile.kkal * myProfile.carb) / 100 / 4)} г.
          </p>
        </div>
        <Slider
          disabled={!isManual}
          defaultValue={20}
          step={10}
          min={0}
          max={100}
          value={myProfile.carb}
          onChange={(value) => onChange("carb", parseInt(value))}
        />
        <Space style={{ height: 32 }} />
        <Button color="danger" block size="large">
          Купить PRO-версия
        </Button>
      </Grid.Item>
    </Grid>
  )
}

export default Profile
